import { createSelector, } from 'reselect';
import { propOr, prop, } from 'ramda';

export const roundSelector = prop('round');

export const firstCardHandsSelector = createSelector(
  roundSelector,
  propOr({}, 'firstCardHands')
);
